export class MessageFilterParameters {
  searchString?: string;
  systemOnly?: boolean;
  minCreatedDate?: string;
  maxCreatedDate?: string;

  constructor(
    searchString?: string,
    systemOnly?: boolean,
    minCreatedDate?: string,
    maxCreatedDate?: string
  ) {
    this.searchString = searchString;
    this.systemOnly = systemOnly;
    this.minCreatedDate = minCreatedDate;
    this.maxCreatedDate = maxCreatedDate;
  }

  public asSearchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.searchString) searchParams.append(
      "searchString",
      this.searchString
    );
    if (this.systemOnly) searchParams.append(
      "systemOnly",
      this.systemOnly.toString()
    );
    if (this.minCreatedDate) searchParams.append(
      "minCreatedDate",
      this.minCreatedDate
    );
    if (this.maxCreatedDate) searchParams.append(
      "maxCreatedDate",
      this.maxCreatedDate
    );
    return searchParams;
  }

  public isEqualTo(other: MessageFilterParameters): boolean {
    if (!other) return false;
    return this.searchString === other.searchString &&
      this.systemOnly === other.systemOnly &&
      this.minCreatedDate === other.minCreatedDate &&
      this.maxCreatedDate === other.maxCreatedDate;
  }
}

export default class MessageParameters {
  filterParameters: MessageFilterParameters;

  constructor(
    filterParameters: MessageFilterParameters
  ) {
    this.filterParameters = filterParameters;
  }

  public asSearchParams(): URLSearchParams {
    return new URLSearchParams([
      ...this.filterParameters.asSearchParams()
    ]);

  }

  public isEqualTo(other: MessageParameters | undefined): boolean {
    if (!other) {
      return false;
    }

    return this.filterParameters.isEqualTo(other.filterParameters);
  }
}
